export default "__VITE_ASSET__BwYzA1qy__"